import CheckIcon from '@mui/icons-material/Check'
import { Badge, IconButton, Tooltip, useTheme } from '@mui/material'
import { GridFilterModel } from '@mui/x-data-grid-premium'
import React, { useMemo } from 'react'
import { User } from 'types'

const FilterMyDataButton = ({
  profile,
  icon,
  filterModel,
  onClick,
  label,
}: {
  profile?: User
  icon: React.ReactNode
  filterModel: GridFilterModel
  onClick: () => void
  label: string
}) => {
  const theme = useTheme()
  // const isFilterActive =
  //   filterModel && Array.isArray(filterModel.quickFilterValues) && filterModel.quickFilterValues.length > 0
  const user_name = profile?.name || profile?.display_name || profile?.real_name
  const isOwnerFilterActive = useMemo(() => {
    return (
      filterModel &&
      profile &&
      Array.isArray(filterModel.quickFilterValues) &&
      filterModel.quickFilterValues?.includes(user_name)
    )
  }, [filterModel, profile])

  return (
    <Tooltip title={label}>
      <IconButton
        sx={{
          borderRadius: '0px',
        }}
        onClick={onClick}
      >
        <Badge
          badgeContent={
            <CheckIcon
              sx={{
                fontSize: '18px',
                color: isOwnerFilterActive ? theme.palette.text.success : theme.palette.text.secondary,
              }}
            />
          }
        >
          {icon}
        </Badge>
      </IconButton>
    </Tooltip>
  )
}

export default FilterMyDataButton
